import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Text as RACText } from 'react-aria-components';
import { Size } from '../../constants/size.js';
import { twMerge } from '../../utils/twMerge.js';
/**
 * The `<Text>` component is a wrapper with no semantic meaning that applies text styling. Prefer semantic elements e.g.
 * `<Paragraph>` when appropriate.
 */
export const Text = forwardRef(function Text({ size = Size.Default, variant = 'default', isDisabled = false, ...textProps }, forwardedRef) {
    return (_jsx(RACText, { ...textProps, ref: forwardedRef, className: twMerge(
        // component name
        `ppl-Text ppl-Text--${variant}`, 
        // text classes
        isDisabled && 'opacity-40', {
            compact: 'text-body-sm',
            default: 'text-body-md',
            loose: 'text-body-lg',
        }[size], {
            default: 'text-default',
            subdued: 'text-default-subdued',
            warning: 'text-warning',
            critical: 'text-critical',
            inverse: 'text-inverse-default',
        }[variant], 
        // user styles
        textProps.className) }));
});
//# sourceMappingURL=Text.js.map